<template>
  <div class="cart_insurance_area txt_insurance-title withTooltip">
    <span class="sstit">소비자피해보상보험 가입 안내 보기</span>
    <div
      class="toolTip-wrapper toolTip-type02 type-mob-full"
      :class="classToolTip"
    >
      <button
        type="button"
        class="btn-tooltip"
        @click="isTooltipOpen = !isTooltipOpen"
      >
        <span class="hidden">안내</span>
      </button>
      <div class="tipCont-wrapper">
        <div class="tooltip-content" :style="styleToolTip">
          <ul class="list-type5">
            <li>
              전자상거래등에서의 소비자보호에관한 법률에 따라 직접판매공제조합에
              가입하여 고객님의 결제금액에 대해 안전거래를 보장하고 있습니다.
            </li>
          </ul>
          <a
            href="https://www.macco.or.kr/ko/cn/KOCNMC01.action"
            target="_blank"
            class="bt-akl-white mini st2"
            >보험가입사실 확인</a
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Insurance",
  data() {
    return {
      isTooltipOpen: false,
    };
  },
  mounted() {
    document.addEventListener("click", this.closeTooltip);
  },
  beforeDestroy() {
    document.removeEventListener("click", this.closeTooltip);
  },
  computed: {
    classToolTip() {
      return this.isTooltipOpen ? "open" : "";
    },
    styleToolTip() {
      return this.isTooltipOpen ? { display: "block" } : { display: "none" };
    },
  },
  methods: {
    closeTooltip(event) {
      // 툴팁 내부를 클릭했으면 닫지 않음
      if (this.$el.querySelector(".toolTip-wrapper").contains(event.target)) {
        return;
      }
      this.isTooltipOpen = false;
    },
  },
};
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/views/composition/payment/Insurance.vue